import IconBase from "./IconBase";

const RemoveIcon = (props) => (
    <IconBase {...props}>
        <path d="M4 6.5h16" />
        <path d="M9.5 6.5v-2a1.5 1.5 0 0 1 1.5-1.5h2a1.5 1.5 0 0 1 1.5 1.5v2" />
        <path d="M6.5 6.5l.9 12.1a2 2 0 0 0 2 1.9h5.2a2 2 0 0 0 2-1.9l.9-12.1" />
        <path d="M10.5 10.5v6" />
        <path d="M13.5 10.5v6" />
    </IconBase>
);

export default RemoveIcon;
